module.exports = __webpack_public_path__ + "2dc7ff4d6219c99e8e5d2fb9f669ff56.png";